/**
 * Umbraco URL helpers.
 *
 * UMBRACO_URL        — public Umbraco origin. Baked into client-visible output
 *                      (image src, CSP, og:image, sitemap).
 * UMBRACO_URL_SERVER — internal Umbraco origin used for server-side fetches
 *                      (Delivery API, search proxy). Falls back to UMBRACO_URL
 *                      when not set so local dev keeps working with one URL.
 */

const stripTrailingSlash = (url: string): string => url.replace(/\/$/, "")

/**
 * URL to use for server-side requests (Delivery API, search, draft preview).
 * Prefers UMBRACO_URL_SERVER, falls back to UMBRACO_URL.
 */
export const getUmbracoServerUrl = (): string => {
  const url = process.env.UMBRACO_URL_SERVER || process.env.UMBRACO_URL
  return url ? stripTrailingSlash(url) : ""
}

/**
 * Public Umbraco URL — for output that ends up in the browser
 * (image src, CSP connect-src, image remotePatterns).
 */
export const getUmbracoPublicUrl = (): string => {
  const url = process.env.UMBRACO_URL || process.env.NEXT_PUBLIC_UMBRACO_URL
  return url ? stripTrailingSlash(url) : ""
}
